import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    viewType: 'tripList',
};

const tripViewSlice = createSlice({
    name: 'tripView',
    initialState,
    reducers: {
        setViewType: (state, action) => {
            //console.log("setting trip view type: ", action.payload, "Current State: ", state.viewType, "Current State: ", state.selectedTrip);
            state.viewType = action.payload;
        },
    },
});

export const selectViewType = (state) => state.tripView.viewType;

export const { setViewType } = tripViewSlice.actions;
export { tripViewSlice };

